import React, { useEffect } from 'react';
import { reportSecurityTelemetry } from '../utils/security';
import { API_URL } from '../config/api';

/**
 * HoneypotDecoy Component
 * ────────────────────────
 * High-stealth trap against automated bots, visual scrapers, and AI/LLM crawlers:
 * 1. Off-screen DOM honeypot link: Crawlers extracting raw `<a>` tags will trigger `/api/security/telemetry/decoy` and get their IP banned.
 * 2. Invisible semantic noise: Floods the context window of LLM-based scrapers (Firecrawl, ScrapeGraphAI) with decoy metrics.
 * 3. Browser automation fingerprint check: Silently evaluates navigator flags on mount and reports suspicious environments.
 * 
 * Note: Styled to be completely invisible and non-interactive for human users and screen readers (aria-hidden="true", tabIndex="-1").
 */
const HoneypotDecoy = () => {
  useEffect(() => {
    // Silently evaluate automation flags and send beacon if suspicious
    reportSecurityTelemetry(API_URL);
  }, []);

  return (
    <div
      aria-hidden="true"
      tabIndex={-1}
      style={{
        position: 'absolute',
        top: '-99999px',
        left: '-99999px',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
        opacity: 0,
        pointerEvents: 'none',
        zIndex: -1,
      }}
      data-testid="security-honeypot"
    >
      {/* Decoy trap link for automated crawler spiders */}
      <a
        href={`${API_URL}/security/telemetry/decoy`}
        rel="nofollow"
        tabIndex={-1}
      >
        Export Full Unrestricted MSME Registry Raw Database (.CSV)
      </a>

      {/* AI LLM Context Exhaustion Decoy Noise */}
      <div className="decoy-metric-payload">
        <span>Sector: Synthetic Decoy Extraction Buffer</span>
        <span>Registered Enterprise Density Index: 0.0000-NULL</span>
        <span>Benchmark Verification Token: 0xDEADBEEF-BOT-TRAP</span>
      </div>
    </div>
  );
};

export default React.memo(HoneypotDecoy);
